export const DADOSCADASTRAIS_SET = "deca.SET_DADOSCADASTRAIS";
export const DADOSCADASTRAIS_RESETFORM = "deca.DADOSCADASTRAIS_RESETFORM";
export const GET_SUGGESTION_CONTADOR = "deca.GET_SUGGESTION_CONTADOR";
export const GET_DATA_ABERTURA_CADASTRAL = "deca.GET_DATA_ABERTURA_CADASTRAL";
export const GET_DATA_OCORRENCIA = "deca.GET_DATA_OCORRENCIA";
export const GET_DATA_NASCIMENTO_CADASTRAL =
  "deca.GET_DATA_NASCIMENTO_CADASTRAL";
export const OPEN_MODAL_CONTADOR = "deca.OPEN_MODAL_CONTADOR";
export const SAVE_CONTADOR_CONTRIBUINTE = "deca.SAVE_CONTADOR_CONTRIBUINTE";
export const SET_CONTADOR_CONTRIBUINTE = "deca.SET_CONTADOR_CONTRIBUINTE";
export const RESET_CONTADOR_CONTRIBUINTE = "deca.RESET_CONTADOR_CONTRIBUINTE";
export const RESET_DATA_ABERTURA_CADASTRAL =
  "deca.RESET_DATA_ABERTURA_CADASTRAL";
export const RESET_DATA_OCORRENCIA = "deca.RESET_DATA_OCORRENCIA";
